<template>
  <v-dialog v-model="dialog" width="450" persistent>
    <v-card :loading="loading">
      <v-form @submit.prevent="alterarSenha()">
        <v-card-title class="font-weight-light">Alterar senha</v-card-title>
        <v-card-text>
          <v-text-field
            :type="passwordType('senhaAtual')"
            v-model="senhaAtual"
            :error-messages="errosSenhaAtual"
            v-touch="senhaAtual"
            prepend-icon="mdi mdi-lock"
            :append-icon="passwordIcon('senhaAtual')"
            label="Senha atual"
            @click:append="
            hiddenPassword.senhaAtual = !hiddenPassword.senhaAtual
          "
          />
          <v-text-field
            :type="passwordType('novaSenha')"
            v-model="novaSenha"
            :error-messages="errosNovaSenha"
            v-touch="novaSenha"
            prepend-icon="mdi mdi-lock-reset"
            :append-icon="passwordIcon('novaSenha')"
            label="Nova senha"
            @click:append="
            hiddenPassword.novaSenha = !hiddenPassword.novaSenha
          "
          />
          <v-text-field
            :type="passwordType('confirmacaoSenha')"
            v-model="confirmacaoSenha"
            :error-messages="errosConfirmacaoSenha"
            v-touch="confirmacaoSenha"
            prepend-icon="mdi mdi-lock-alert"
            :append-icon="passwordIcon('confirmacaoSenha')"
            label="Confirme a senha"
            @click:append="
            hiddenPassword.confirmacaoSenha = !hiddenPassword.confirmacaoSenha
          "
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">CANCELAR</v-btn>
          <v-btn color="accent" depressed type="submit" :loading="loading">
            <v-icon class="mdi mdi-check mr-2" />ALTERAR SENHA
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      hiddenPassword: {
        senhaAtual: true,
        novaSenha: true,
        confirmacaoSenha: true
      },
      senhaAtual: "",
      novaSenha: "",
      confirmacaoSenha: "",
      loading: false
    };
  },
  validations: {
    senhaAtual: {
      required
    },
    novaSenha: {
      required
    },
    confirmacaoSenha: {
      igualNovaSenha: sameAs("novaSenha")
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.usuarios.changePassword.dialog;
      },
      set(value) {
        if (!value) {
          this.senhaAtual = "";
          this.novaSenha = "";
          this.confirmacaoSenha = "";
          this.$v.$reset();
        }
        this.$store.commit("usuarios/toggleChangePasswordDialog", value);
      }
    },
    errosSenhaAtual() {
      const errors = [];
      if (this.$v.senhaAtual.$dirty && !this.$v.senhaAtual.required) {
        errors.push("Informe a senha atual.");
      }
      return errors;
    },
    errosNovaSenha() {
      const errors = [];
      if (this.$v.novaSenha.$dirty && !this.$v.novaSenha.required) {
        errors.push("Digite a nova senha");
      }
      return errors;
    },
    errosConfirmacaoSenha() {
      const errors = [];
      if (
        this.$v.confirmacaoSenha.$dirty &&
        !this.$v.confirmacaoSenha.igualNovaSenha
      ) {
        errors.push("A confirmação de senha falhou");
      }
      return errors;
    }
  },
  methods: {
    passwordType(field) {
      return this.hiddenPassword[field] ? "password" : "text";
    },
    passwordIcon(field) {
      return this.hiddenPassword[field] ? "mdi mdi-eye" : "mdi mdi-eye-off";
    },
    async alterarSenha() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        const ok = await this.$store.dispatch("usuarios/alterarSenha", {
          senha_atual: this.senhaAtual,
          nova_senha: this.novaSenha
        });
        if (ok) {
          this.dialog = false;
        }
        this.loading = false;
      }
    }
  }
};
</script>
